var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDiscussLine({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_35632_103278)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.6667 18.7503L9.33337 15.8337H5.00004C4.77903 15.8337 4.56707 15.7459 4.41079 15.5896C4.25451 15.4333 4.16671 15.2213 4.16671 15.0003V5.91949C4.16671 5.69848 4.25451 5.48652 4.41079 5.33024C4.56707 5.17396 4.77903 5.08616 5.00004 5.08616H18.3334C18.5544 5.08616 18.7664 5.17396 18.9226 5.33024C19.0789 5.48652 19.1667 5.69848 19.1667 5.91949V15.0003C19.1667 15.2213 19.0789 15.4333 18.9226 15.5896C18.7664 15.7459 18.5544 15.8337 18.3334 15.8337H14L11.6667 18.7503ZM13.1992 14.167H17.5V6.75283H5.83337V14.167H10.1342L11.6667 16.082L13.1992 14.167ZM1.66671 1.66699H15.8334V3.33366H2.50004V12.5003H0.833374V2.50033C0.833374 2.27931 0.921171 2.06735 1.07745 1.91107C1.23373 1.75479 1.44569 1.66699 1.66671 1.66699Z",
    fill: "#0024A9"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_35632_103278"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDiscussLine);
export default __webpack_public_path__ + "static/media/discuss-line.c4c82e29ebabd0ad1224f6da31982859.svg";
export { ForwardRef as ReactComponent };